<div class="waiting-dots">
  <div class="mx-1"></div>
  <div class="mx-1"></div>
  <div class="mx-1"></div>
</div>
